import { ArrayParam, useQueryParam, withDefault } from "use-query-params";

import { ExploreBudgetsTrackedComponent } from "@pages/mmm/amplitude-tracking/components";
import { MMMTab } from "@pages/mmm/amplitude-tracking/mmm-event";
import { useTrackMMMEvent } from "@pages/mmm/amplitude-tracking/use-track-mmm-event";

const createBreakdownIdentifier = (
  breakdownKey: string,
  breakdownValue: string,
) => `${breakdownKey}:${breakdownValue}`;

export const useExpandedBreakdowns = () => {
  const trackMMMEvent = useTrackMMMEvent(MMMTab.EXPLORE_BUDGETS);

  const [expandedBreakdowns, setExpandedBreakdowns] = useQueryParam(
    "expanded-breakdowns",
    withDefault(ArrayParam, [] as string[]),
  );

  const unexpandBreakdown = (breakdownKey: string, breakdownValue: string) => {
    trackMMMEvent({
      component: ExploreBudgetsTrackedComponent.BUDGET_MIX_CARD,
      action: "onClick",
      actionInfo: "Click un-expand breakdown in mix chart bar",
      data: { breakdown: breakdownValue },
    });

    setExpandedBreakdowns((prevExpandedBreakdowns) => {
      if (!prevExpandedBreakdowns) {
        return [];
      }

      return prevExpandedBreakdowns.filter(
        (breakdown) =>
          breakdown !== createBreakdownIdentifier(breakdownKey, breakdownValue),
      );
    });
  };

  const expandBreakdown = (breakdownKey: string, breakdownValue: string) => {
    trackMMMEvent({
      component: ExploreBudgetsTrackedComponent.BUDGET_MIX_CARD,
      action: "onClick",
      actionInfo: "Click expand breakdown in mix chart bar",
      data: { breakdown: breakdownValue },
    });

    setExpandedBreakdowns((prevExpandedBreakdowns) => {
      if (!prevExpandedBreakdowns) {
        return [];
      }

      return [
        ...new Set([
          ...prevExpandedBreakdowns,
          createBreakdownIdentifier(breakdownKey, breakdownValue),
        ]),
      ];
    });
  };

  const isBreakdownExpanded = (breakdownKey: string, breakdownValue: string) =>
    expandedBreakdowns.includes(
      createBreakdownIdentifier(breakdownKey, breakdownValue),
    );

  return {
    unexpandBreakdown,
    expandBreakdown,
    isBreakdownExpanded,
  };
};
